import { StepLocationRelativeToParent } from '@activepieces/shared';
import {
  BaseEdge,
  EdgeProps,
  getSmoothStepPath,
  Position,
} from '@xyflow/react';

import { flowUtilConsts } from '../utils/consts';
import { ApLoopStartEdge } from '../utils/types';

import { ApAddButton } from './add-button';

export const ApLoopStartLineCanvasEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
  source,
  id,
}: EdgeProps & ApLoopStartEdge) => {
  const sourcePosition = Position.Right;
  const targetPosition = Position.Left;
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX: sourceX - 10,
    sourceY: sourceY + 10,
    sourcePosition,
    targetX: data.isLoopEmpty
      ? targetX - flowUtilConsts.AP_NODE_SIZE.BIG_ADD_BUTTON.width / 2
      : targetX,
    targetY: data.isLoopEmpty
      ? targetY + flowUtilConsts.AP_NODE_SIZE.BIG_ADD_BUTTON.height / 1.8
      : targetY,
    targetPosition,
  });

  const buttonPosition = {
    x: labelX - flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width / 2,
    y: labelY - flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height / 2,
  };

  return (
    <g>
      <BaseEdge
        path={edgePath}
        style={{
          strokeWidth: `${flowUtilConsts.LINE_WIDTH}px`,
          stroke: data.hover ? '#ff0000' : '#999999',
          transition: 'stroke 0.2s ease',
        }}
        className="animated-edge"
      ></BaseEdge>
      {!data.isLoopEmpty && data.hover && (
        <foreignObject
          x={buttonPosition.x}
          y={buttonPosition.y}
          width={flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width}
          height={flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height}
          className="overflow-visible cursor-default"
        >
          <ApAddButton
            edgeId={id}
            stepLocationRelativeToParent={
              StepLocationRelativeToParent.INSIDE_LOOP
            }
            parentStepName={source}
          ></ApAddButton>
        </foreignObject>
      )}
    </g>
  );
};
